<template>
  <div>
    <CardItemMeter :metrics="roundedMetrics" :getMeterClasses="getMeterClasses" :getInnerMeterClasses="getInnerMeterClasses"/>
    <CardItemPercent :metrics="roundedMetrics" :getTextClasses="getTextClasses"/>
    <CardItemFooter :performanceTypes="performanceTypes" :getFooterClasses="getFooterClasses"/>
  </div>
</template>

<script>

import CardItemMeter from './CardItemMeter/CardItemMeter';
import CardItemPercent from './CardItemPercent/CardItemPercent';
import CardItemFooter from './CardItemFooter/CardItemFooter';
import cardItemMixin from './cardItemMixin';

export default {
  props: {
    performanceTypes: {
      type: Array,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    },
  },
  computed: {
    roundedMetrics() {
      const { metrics } = this
      const totalPerentage = 100

      const mappedNumbers = metrics.map(num => Math.floor(num))
      const lowerSum = mappedNumbers.reduce((a, b) => a + b, 0)
      let delta = totalPerentage - lowerSum

      for (let i = mappedNumbers.length - 1; delta > 0; i--) {
        mappedNumbers[i]++
        delta--
      }

      return mappedNumbers
    }
  },
  components: {
    CardItemMeter,
    CardItemPercent,
    CardItemFooter,
  },
  mixins: [cardItemMixin]
}
</script>
